import { Component } from '@angular/core';

@Component({
  selector: 'app-lollipop-chart-custom',
  template: '<app-chart-output></app-chart-output>'
})
export class LollipopChartComponentCustom {

}
